import * as React from 'react';
import { assign as _assign } from 'lodash';
import { Button } from 'reactstrap';

import './ConfigurationDuplicate.page.scss';
import { requestAPIActions } from 'loopback-react-request';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationDuplicate.messages';

export interface ConfigurationDuplicateProps {
  dispatch: any;
  configuration: GlobalPrivateState['configuration'];
  userData: GlobalPrivateState['userData'];
  user: GlobalPrivateState['user'];
}

export interface ConfigurationDuplicateState {
  redirect: boolean;
}

export class ConfigurationDuplicatePartial extends React.Component<ConfigurationDuplicateProps, ConfigurationDuplicateState> {
  constructor(props: ConfigurationDuplicateProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      redirect: false,
    };
  }

  componentDidUpdate (prevProps: ConfigurationDuplicateProps) {
    const configuration = this.configuration;
    const prevConfiguration = prevProps.configuration.result;

    if ((configuration && configuration.id) !== (prevConfiguration && prevConfiguration.id)) {
      if (!this.state.redirect) {
        this.setState({
          redirect: true,
        });
      }
    }
  }

  public render() {
    return (
      <div className="page-configuration-duplicate d-flex justify-content-center align-items-center vh-100">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h3 className="mb-5">
                <FormattedMessage {...MESSAGES.configurationDuplicateHeadline} />
              </h3>
              <Button
                onClick={this.handleClick}
                className="btn"
              >
                <FormattedMessage {...MESSAGES.configurationDuplicateButton} />
              </Button>
            </div>
          </div>
        </div>
        {this.state.redirect && (
          <Redirect to={`/`} />
        )}
      </div>
    );
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private dispatchDuplicate() {
    const user = this.props.user.result;
    const userData = this.props.userData.result;
    const configuration = this.configuration;
    if (!configuration || !userData || !user) {
      return;
    }

    Object.keys(configuration).map(key => {
      if (configuration) {
        switch (key) {
          case 'created_at':
          case 'id':
          case 'projects':
          case 'updated_at':
          case 'user':
          case 'userData':
          case 'calculation':
          case 'order':
					case 'orderId':
					case 'sapNumber':
          case 'remainingMethods':
            delete configuration[key];
            break;
          default:
            return;
        }
      }
    });

		if (configuration.folderId && configuration.userId !== user.id) {
			delete configuration.folderId;
		}
    
    configuration.completionStatus = 'draft';
    configuration.name = this.changeName(configuration.name);
    configuration.userId = user.id;
    configuration.userdataId = userData.id;
    
    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/UserData/${userData.id}/Configurations`,
        options: {
          method: 'POST',
          data: configuration,
        },
      },
      true,
    ));
  }

  private handleClick(event: React.SyntheticEvent<HTMLButtonElement>) {
    this.dispatchDuplicate();
  }

  private changeName(name: string) {
    const numberRegEx = (str: string): string[] => {
      const regex = /(\()(\d+)(\))/gm;
      let m;

      const matchArray: string[] = [];
      while ((m = regex.exec(str)) !== null) {
        if (m.index === regex.lastIndex) {
          regex.lastIndex++;
        }
        
        m.forEach((match, groupIndex) => {
          matchArray.push(match);
        });
      }
      return matchArray;
    };
    
    let nextNumber = 1;
    let newName = name;
    if (name.indexOf('Copy') > -1) {
      let getNumber = numberRegEx(name);
      if (getNumber.length > 0 && getNumber[2]) {
        const currentNumber = Number(getNumber[2]);
        nextNumber = currentNumber + 1;
      }
      newName = name.replace(/ Copy \(\d+\)/, '');
    }
    newName = `${newName} Copy (${nextNumber})`;
    return newName;
  }
}

export const ConfigurationDuplicate = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  userData: state.userData,
  user: state.user
}))(ConfigurationDuplicatePartial);

export default ConfigurationDuplicate;
